import sublevel from 'subleveldown'

const _self = {
  sub: (db, path, options) => {
    var sub = sublevel(db, path, options)

    if ((typeof sub._db.db['approximateSize']) !== 'function') {
      // https://github.com/Level/subleveldown/issues/22
      // `approximateSize` is leveldown specific and no longer part of the latest abstract-leveldown hence it was removed
      // But [levelgraph](https://github.com/levelgraph/levelgraph) relies on this function when searching
      // therefore replacing it back in a slightly hackish manner
      sub._db.db.approximateSize = function (start, end, cb) {
        this.leveldown.approximateSize.apply(this.leveldown, arguments)
      }
    }

    return sub
  }
}

export default _self
